import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from './guards/authentication.guard';
import { LoginComponent } from './modules/credentials/login/login.component';
import { RecoverPasswordComponent } from './modules/credentials/recover-password/recover-password.component';
import { RedefinePasswordComponent } from './modules/credentials/redefine-password/redefine-password.component';
import { RegistrationPasswordComponent } from './modules/credentials/registration-password/registration-password.component';
import { RegistrationComponent } from './modules/credentials/registration/registration.component';
import { DownloadGuidanceComponent } from './modules/nutritional-guidance/components/download-guidance/download-guidance.component';
import { NotFoundComponent } from './modules/not-found/not-found.component';
import { APP_BASE_HREF } from '@angular/common';
import { EnvironmentService } from './services/environment.service';
import { UpdateCpfComponent } from './modules/credentials/update-cpf/update-cpf.component';
import { AdminAuthComponent } from './modules/admin-auth/admin-auth.component';
import { msalGuard } from './guards/admin-authentication.guard';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'cadastro_sucesso_login', component: LoginComponent },
  { path: 'cadastro_sucesso_estudante_login', component: LoginComponent },
  { path: 'cadastro', component: RegistrationComponent },
  { path: 'cadastrar-senha', component: RegistrationPasswordComponent },
  { path: 'recuperar-senha', component: RecoverPasswordComponent },
  { path: 'redefinir-senha/:email', component: RedefinePasswordComponent },
  { path: 'atualizar-cpf', component: UpdateCpfComponent },
  { path: 'verification', component: RegistrationPasswordComponent },
  { path: 'reset-password', component: RegistrationPasswordComponent },
  {
    path: 'baixar-orientacao/:id/:email/:phone/:pet/:tutorId/:petId/:orientationId/:vetId',
    component: DownloadGuidanceComponent
  },
  { path: 'admin/login', component: AdminAuthComponent },
  {
    path: 'admin',
    canActivate: [msalGuard, MsalGuard],
    loadChildren: () =>
      import('../app/modules/admin/admin.module').then((m) => m.AdminModule)
  },

  {
    path: '',
    canActivate: [AuthenticationGuard],
    loadChildren: () =>
      import('../app/modules/home/home.module').then((m) => m.HomeModule)
  },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled'
    })
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: new EnvironmentService().isReactNativeWebView ? '/app' : '/'
    }
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
